import React, { useState } from "react";
import http from "./../../../Services/http";
import Loader from "react-loader-spinner";
import aproveImage from "./../../../Media/dashborad/approve.svg";
import "./ApproveOrder.css";

const ApproveOrder = ({ props }) => {

  const [loader, setLoader] = useState(false);
  const approveOrder = async () => {
    try {
      setLoader(true);
      await http.post(`/orders/pending/${props.match.params.id}`, null, {
        headers: {
          "x-token": localStorage.getItem("token"),
        },
      });
      console.log("deleted");

      window.location = "/dashborad/orders/approved";
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  if (loader)
    return <Loader type="ThreeDots" color="#ef92c8" height={200} width={200} />;

  return (
    <div className="delete">
      <div className="delete__box">
        <h3 className="section__title">Are You Sure?</h3>
        <button className="btn btn-signup m-r-s b-f-s" onClick={approveOrder}>
          Approve
        </button>
        <button
          className="btn btn-order b-f-s"
          onClick={() => (window.location = "/dashborad")}
        >
          Cancel
        </button>
      </div>

      <div className="delete__img--container">
        <img src={aproveImage} className="delete__img" alt="delete" />
      </div>
    </div>
  );
};

export default ApproveOrder;
